import React, { useContext } from "react";
import {
  Nav,
  Navbar,
  NavDropdown,
  Container,
  Form,
  Row,
  Col,
  FormControl,
  Button,
} from "react-bootstrap";
import SelectSearch from "react-select-search";
import {
  Route,
  BrowserRouter,
  Switch,
  Link,
  useHistory,
} from "react-router-dom";
import Dashboard from "./screens/Dashboard";
import Home from "./screens/Home";
import Login from "./screens/Login";
import { toast } from "react-toastify";
import ProtectedRoute from "./utility/ProtectedRoute";
import DashboardRoute from "./utility/DashboardRoute";
import "bootstrap/dist/css/bootstrap.min.css";
import { GlobalContext } from "./utility/GlobalContext";
import authService from "./services/authService";
import SocialPage from "./screens/Creator/SocialPage";
import "./App.css";
import mainService from "./services/mainService";

import tiktokIcon from "../src/assets/images/tiktok-icon.png";
import instagramIcon from "../src/assets/images/instagram-icon.png";
import businessIcon from "../src/assets/images/business-icon.png";
import BusinessPage from "./screens/Business/BusinessPage";
import CreateAndReviewBusiness from "./screens/Business/CreateAndReviewBusiness";
import CreateAndReview from "./screens/Other/CreateAndReview";

function App(props) {
  const { state, setState } = useContext(GlobalContext);
  const history = useHistory();
  const logout = () => {
    toast.success("Logged out");
    authService.logout(state, setState);
    history.push("/");
  };

  const getSearchImage = (type) => {
    if (type === "business") {
      return businessIcon;
    }
    if (type === "tiktok") {
      return tiktokIcon;
    }
    if (type === "instagram") {
      return instagramIcon;
    }
  };

  const getSearchRoute = (data) => {
    const { type, name, value } = data;
    if (type === "business") {
      return `/${type}/${value}`;
    } else if (type === "new") {
      return "/new_review";
    } else {
      return `/${type}/${name}`;
    }
  };

  const optionThing = (domProps, options, snapshot, className) => {
    return (
      <div
        className="select-search__option"
        onClick={() => {
          history.push(getSearchRoute(options));
        }}
      >
        <Container>
          {options.type !== "new" ? (
            <Row>
              <Col xs={2}>
                <img
                  style={{ width: 25, height: 25 }}
                  src={getSearchImage(options.type)}
                />
              </Col>
              <Col>
                <p style={{ fontSize: 20 }}>{options.name}</p>
              </Col>
            </Row>
          ) : (
            <Row>
              <p style={{ fontSize: 18 }}>{options.name}</p>
            </Row>
          )}
        </Container>
      </div>
    );
  };

  const searchBar = () => (
    <div className="col-lg-4 col-xs-12">
      <SelectSearch
        options={[]}
        renderOption={optionThing}
        getOptions={(query) => {
          return new Promise((resolve, reject) => {
            mainService
              .search(query)
              .then(({ data }) => {
                const totalData = data;
                if (query !== "") {
                  totalData.push({
                    value: "new",
                    name: "Cant find it? Be the first to review",
                    type: "new",
                  });
                }
                resolve(
                  totalData.map(({ id, name, type }) => ({
                    value: id,
                    name: name,
                    type: type,
                  }))
                );
              })
              .catch(reject);
          });
        }}
        search
        placeholder="Search..."
      />
      {/* <FormControl style={{width: 300}} type="text" placeholder="Search" className="mr-sm-2" /> */}
      {/* <Button variant="outline-success">Search</Button> */}
    </div>
  );

  return (
    <div>
      <Navbar bg="dark" expand="lg" variant="dark">
        <Navbar.Brand href="/">Sociable</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          {!state.jwt ? (
            <Nav className="mr-auto">
              <Nav.Link
                // href="/login?type=creator"
                onClick={() => history.push("/login?type=creator")}
                style={{ color: "whitesmoke" }}
              >
                Creator Login
              </Nav.Link>
              <Nav.Link
                onClick={() => history.push("/login?type=business")}
                style={{ color: "whitesmoke" }}
              >
                Brand Login
              </Nav.Link>
            </Nav>
          ) : (
            <Nav className="mr-auto">
              <Nav.Link href="/new_review" style={{ color: "whitesmoke" }}>
                Write a review
              </Nav.Link>
              <Nav.Link onClick={logout} style={{ color: "whitesmoke" }}>
                Logout
              </Nav.Link>
            </Nav>
          )}
          {searchBar()}
        </Navbar.Collapse>
      </Navbar>

      <Switch>
        {/* <Route exact path="/" component={Home} /> */}
        <Route exact path="/login" component={Login} />
        <DashboardRoute exact={true} path="/" component={Dashboard} />
        <Route path="/instagram/:handle" children={<SocialPage />} />
        <Route path="/tiktok/:handle" children={<SocialPage />} />
        <Route path="/business/:id" children={<BusinessPage />} />
        <ProtectedRoute path="/new_review" component={CreateAndReview} />
      </Switch>
    </div>
  );
}

export default App;
